import React, { Fragment, useCallback, useState, useEffect, useRef } from "react";
import { 
    Card, 
    CardBody, 
    Row, 
    Col,
    Modal,
    ModalHeader,
    ModalBody
} from 'reactstrap';

import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import Select from 'react-select';
import api from '../../../../../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../../../../../Context/Auth/AuthContext';
import GiftStatuses from '../../../../../enums/GiftStatuses';
import { completedColor } from '../../../../../config/calendar';

const localizer = momentLocalizer(moment);

export default function GiftsCalendar(props) {
    const { givers, activeTab } = props;
    const { toggleLoading, currentGroup, globalUpdate, setGlobalUpdate } = useAuth();
    const selectRef = useRef();

    const [enableGiverFilter] = useState(true);
    const [currentGiver, setCurrentGiver] = useState();

    const options = () => {
        let options = [];
        // eslint-disable-next-line
        if (givers) {
            givers.map((giver) => {
                options.push(
                    {
                        value: giver.id,
                        label: giver.name
                    }
                )
                return giver;
            });
        }

        options.push({
            value: '',
            label: 'All'
        });
        
        return options;
    }

    const [events, setEvents] = useState([]);
    const [originalEvents, setOriginalEvents] = useState([]);
    const [targetEvent, setTargetEvent] = useState();
    const [currentCallLogs, setCurrentCallLogs] = useState();

    const [modalTargetEvent, setModalTargetEvent] = useState(false);
    const toggleModalTargetEvent = useCallback(() => {
        setModalTargetEvent(!modalTargetEvent);
    }, [setModalTargetEvent, modalTargetEvent]);

    const convertLabelDate = useCallback((system_date) => {
        if (system_date) {
            const month = parseInt(system_date.substring(4,6)) - 1;
            const date = new Date(
                system_date.substring(0,4),
                month,
                system_date.substring(6,8),
                system_date.substring(8,10),
                system_date.substring(10,12),
                0
            );
            return date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
        }
        return '';
    }, []);
    
    const convertDate = useCallback((system_date) => {
        if (system_date) {
            const month = parseInt(system_date.substring(4,6)) - 1;
            const date = new Date(
                system_date.substring(0,4),
                month,
                system_date.substring(6,8),
                system_date.substring(8,10),
                system_date.substring(10,12),
                0
            );
            return date;
        }
        return null;
    }, []);

    const setEnabledCallLog = useCallback(async(targetEvent) => {
        const result = await api.post(`/ro.team.listLogGiftByGiftId/${currentGroup.id}`, {
            giftId: targetEvent.id
        });

        if (result.data.length > 0) {
            setCurrentCallLogs(result.data);
            return true;
        }
        setCurrentCallLogs([]);
    }, [currentGroup, setCurrentCallLogs]);

    const getGifts = useCallback(() => {
        setEvents([]);
        setOriginalEvents([]);
        toggleLoading(true);
        api.get(`/ro.team.listGroupScheduleGifts/${currentGroup.id}`)
            .then((response) => {
                const events_remote = response.data;
                if (events_remote && events_remote.length > 0) {
                    const calendar_events = [];
                    setOriginalEvents(events_remote);
                    events_remote.map((event, index) => {
                        calendar_events.push({
                            id: event.id,
                            title: `${convertLabelDate(event.date)} ${event.receiver.name} [${event.giver.name}]`,
                            start: convertDate(event.date),
                            end: convertDate(event.date),
                            color: (event.status === GiftStatuses.COMPLETED) ? completedColor : undefined
                        });
                        return event;
                    });
                    setEvents(calendar_events);
                }
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            })
            .finally(() => {
                toggleLoading(false);
            });
    }, [toggleLoading, currentGroup, setEvents, convertDate, setOriginalEvents, convertLabelDate]);

    const changeGiver = useCallback((event) => {
        const currentGiverId = event.value;
        // const currenReceiverName = event.label;
        if (currentGiverId) {
            setCurrentGiver(currentGiverId);
            setEvents([]);
            setOriginalEvents([]);
            toggleLoading(true);
            api.post(`/ro.team.listScheduleGiftsForGiver/${currentGroup.id}`, {
                giverId: currentGiverId
            })
                .then((response) => {
                    const events_remote = response.data;
                    if (events_remote && events_remote.length > 0) {
                        const calendar_events = [];
                        setOriginalEvents(events_remote);
                        events_remote.map((event, index) => {
                            calendar_events.push({
                                id: event.id,
                                title: `${convertLabelDate(event.date)} ${event.receiver.name} [${event.giver.name}]`,
                                start: convertDate(event.date),
                                end: convertDate(event.date),
                                color: (event.status === GiftStatuses.COMPLETED) ? completedColor : undefined
                            });
                            return event;
                        });
                        setEvents(calendar_events);
                    }
                })
                .catch((err) => {
                    toast.error(err.response.data.message);
                })
                .finally(() => {
                    toggleLoading(false);
                });
        } else {
            getGifts();
        }
    }, [getGifts, setOriginalEvents, setEvents, convertDate, currentGroup.id, toggleLoading, convertLabelDate, setCurrentGiver]);

    useEffect(() => {
        if (globalUpdate.viewGiverSchedule !== undefined) {
            changeGiver({value:globalUpdate.data.id});
            if (selectRef && selectRef.current !== undefined && selectRef.current.state) {
                selectRef.current.state.value = {value:globalUpdate.data.id, label: globalUpdate.data.name};
            }
            setGlobalUpdate({});
        } else if (JSON.parse(activeTab) === 4) {
            if (currentGiver && currentGiver !== undefined) {
                changeGiver({value:currentGiver});
            } else {
                getGifts();
            }
            
        }
    }, [getGifts, activeTab, globalUpdate, setGlobalUpdate, changeGiver, selectRef, currentGiver]);

    const onSelectEvent = useCallback((event) => {
        if (event.id) {
            var target_event;
            originalEvents.map((e) => {
                if (e.id === event.id) {
                    target_event = e;
                }
                return true;
            });

            if (target_event) {
                setEnabledCallLog(target_event);
                setTargetEvent(target_event);
                toggleModalTargetEvent();
            }
        }
    }, [originalEvents, setTargetEvent, toggleModalTargetEvent, setEnabledCallLog]);

    const convertDateFront = (date) => {
        const month = parseInt(date.substring(4,6)) - 1;
        const dateObj = new Date(
            date.substring(0,4),
            month,
            date.substring(6,8),
            date.substring(8,10),
            date.substring(10,12),
            0
        );
        const hour = dateObj.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });

        return `${date.substring(0,4)}/${date.substring(4,6)}/${date.substring(6,8)} 
        ${hour}`;
    };

    return (
        <Fragment>
            <Card className="mb-3">
                <CardBody>
                    {enableGiverFilter && (
                        <Row className="mb-4">
                            <Col lg="12">
                                <Select
                                    options={options()}
                                    placeholder="Select a  Volunteer"
                                    onChange={changeGiver}
                                    defaultValue={{ value: '', label: 'All' }}
                                    className="z-index-10"
                                    ref={selectRef}
                                />
                            </Col>
                        </Row>
                    )}
                    <Calendar
                        localizer={localizer}
                        events={events}
                        startAccessor="start"
                        endAccessor="end"
                        onSelectEvent={onSelectEvent}
                        views={['month', 'day', 'agenda']}
                        eventPropGetter={event => {
                            if (event.color && event.color !== undefined) {
                                return { style: { backgroundColor: event.color } };
                            }
                        }}
                    />
                </CardBody>
            </Card>

            <Modal isOpen={modalTargetEvent} toggle={toggleModalTargetEvent}>
                <ModalHeader toggle={toggleModalTargetEvent}>
                    Event Details
                </ModalHeader>
                <ModalBody>
                    {targetEvent && (
                        <Fragment>
                            <p><b>Senior</b></p>
                            <p>
                                {targetEvent.receiver.name}
                            </p>

                            <p><b>Volunteer</b></p>
                            <p>
                                {targetEvent.giver.name}
                            </p>

                            <p><b>Date</b></p>
                            <p><i>{convertDateFront(targetEvent.date)}</i></p>

                            {currentCallLogs !== undefined && currentCallLogs.length > 0 && (
                                <Fragment>
                                    <p><b>Call Log:</b></p>
                                    {currentCallLogs.map((item) => (
                                        <p key={item.id}>{item.notes}</p>
                                    ))}
                                </Fragment>
                            )}
                        </Fragment>
                    )}
                </ModalBody>
            </Modal>
        </Fragment>
    )
}
